import DatabaseManager from "./DatabaseManager";

const DatabaseLoader = () => <DatabaseManager />;

export default DatabaseLoader;
